import React from 'react';
import { Kicker, FadeUp, CharReveal } from './ui';
const STEPS = [{
  n: '01',
  title: 'Listen',
  desc: 'Discovery, audit, goals. We learn the business before we touch a pixel, because the wrong brief makes beautiful work useless.'
}, {
  n: '02',
  title: 'Sharpen',
  desc: 'Strategy, positioning, messaging. We find the one thing worth saying and cut everything that dilutes it.'
}, {
  n: '03',
  title: 'Build',
  desc: 'Design, development and motion in tight loops. Weekly demos, honest feedback, no big reveals at the end.'
}, {
  n: '04',
  title: 'Launch & Loop',
  desc: 'Ship, measure, iterate. Nothing is finished, it is improved. We stay close after launch to make the numbers move.'
}];
export function Process() {
  return <section id="process" className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32" data-id="element-145">
      <Kicker ig="Usoro" en="How we work" data-id="element-146" />
      <h2 className="font-display uppercase text-5xl md:text-8xl tracking-tight mt-4" data-id="element-147">
        <CharReveal text="The Process" data-id="element-148" />
      </h2>

      <div className="mt-12 md:mt-16 grid gap-10 md:grid-cols-4 md:gap-8" data-id="element-149">
        {STEPS.map((s, i) => <FadeUp key={s.n} delay={i * 130} data-id="element-150">
            <div className="border-t-2 pt-6 h-full transition-colors" style={{
          borderColor: 'var(--line)'
        }} data-id="element-151">
              <span className="font-monoui text-sm tracking-[0.18em]" style={{
            color: 'var(--danfo)'
          }} data-id="element-152">
                {s.n}
              </span>
              <h3 className="font-display uppercase text-2xl md:text-3xl mt-3 tracking-tight" data-id="element-153">{s.title}</h3>
              <p className="mt-4 text-sm md:text-base leading-relaxed" style={{
            color: 'var(--paper-dim)'
          }} data-id="element-154">
                {s.desc}
              </p>
            </div>
          </FadeUp>)}
      </div>
    </section>;
}